import type { Colors, DefaultTheme } from 'styled-components';
import { mapLightTheme } from './LightTheme';

const colors: Colors = {
  primary: {
    lighten: '#9844b5',
    default: '#793690',
    dim: 'rgba(121,54,144,0.4)',
    mute: 'rgba(121,54,144,0.1)',
  },
  gray: {
    '100': '#1d1d28',
    '000': '#dfdfe2',
    '010': '#ebebee',
    main: '#f8f8fa',
    '020': '#f3f3f5',
    '030': '#e4e4e7',
    '040': '#d5d5d9',
    '050': '#ccccd0',
    '060': '#c2c2c6',
    '070': '#b6b6bb',
    '080': '#96969c',
    '090': '#66666e',
  },
  green: {
    lighten: '#24a349',
    default: '#1b7936',
    dim: 'rgba(27,121,54,0.4)',
    mute: 'rgba(27,121,54,0.1)',
  },
  red: {
    lighten: '#e43942',
    default: '#ce1c25',
    dim: 'rgba(206,28,37,0.4)',
    mute: 'rgba(206,28,37,0.1)',
  },
  yellow: {
    lighten: '#f06400',
    default: '#bd4f00',
    dim: 'rgba(189,79,0,0.4)',
    mute: 'rgba(189,79,0,0.1)',
  },
  orange: {
    lighten: '#2f78fe',
    default: '#0158f9',
    dim: 'rgba(1,88,249,0.4)',
    mute: 'rgba(1,88,249,0.1)',
  },
  blue: {
    lighten: '#5fa2e7',
    default: '#3388E0',
    dim: 'rgba(51,136,224,0.4)',
    mute: 'rgba(51,136,224,0.1)',
  },
  purple: {
    lighten: '#9f73d7',
    default: '#844BCC',
  },
  white: {
    default: '#f8f8fa',
    dim: 'rgba(248,248,250,0.4)',
    mute: 'rgba(248,248,250,0.1)',
  },
  black: {
    default: '#17172b',
    dim: 'rgba(23,23,43,0.4)',
    mute: 'rgba(23,23,43,0.1)',
  },
};

export const LightMarexTheme: DefaultTheme = mapLightTheme(colors, {
  name: 'LightMX',
});
